export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70c8cdac8c05733edecd389a5d79e125d8b4e859d6&name=pushAdClickData!'